import { Component, Inject, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { BasicService } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';

import { UserPreferencesNotifications } from '../shared/models';
import { UserPreferencesService } from '../user-preferences.service';

@Component({
  selector: 'app-user-preferences-notifications',
  templateUrl: './user-preferences-notifications.component.html',
  styleUrls: ['../../user-preferences/shared/user-preferences.scss', './user-preferences-notifications.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserPreferencesNotificationsComponent implements OnDestroy {
  form: FormGroup = this.formBuilder.group({
    HELP_REQUEST: this.formBuilder.group({ mail: [false], notif: [false] }),
    HELP_ANSWER_TO_MY_REQUESTS: this.formBuilder.group({ mail: [false], notif: [false] }),
    HELP_ANSWER_TO_ALL_REQUESTS: this.formBuilder.group({ mail: [false], notif: [false] }),
    TASK_ROUTED_TO_MY_TEAM: this.formBuilder.group({ mail: [false], notif: [false] }),
  });

  subscriptions: Subscription = new Subscription();

  constructor(
    private formBuilder: FormBuilder,
    private alcmeonContextService: AlcmeonContextService,
    private basicService: BasicService,
    private userPreferencesService: UserPreferencesService,
    private errorHandlingService: ErrorHandlingService,
    @Inject('TopToolbarFactory') private topToolbarService: any
  ) {
    topToolbarService.setTitleTranslation('preferences/notifications', null);
    topToolbarService.setButton('save', this.save, null);
    topToolbarService.updateButtonDisable(true, null);
    this.form.patchValue(this.alcmeonContextService.self.notifications_details);
    this.subscriptions = this.form.valueChanges.subscribe(() => topToolbarService.updateButtonDisable(false, null));
  }

  private save = () => {
    this.basicService.showSpinner();
    const notificationsDetails: UserPreferencesNotifications = this.form.value;
    this.userPreferencesService
      .updateNotifications(notificationsDetails)
      .pipe(
        this.errorHandlingService.catchAlertAndThrowHttpError(),
        finalize(() => this.basicService.hideSpinner())
      )
      .subscribe({
        next: () => {
          this.alcmeonContextService.notificationsDetails = notificationsDetails;
          this.basicService.toastSuccess('preferences/account/save_ok');
          this.topToolbarService.updateButtonDisable(true, null);
        },
      });
  };

  ngOnDestroy() {
    this.subscriptions?.unsubscribe();
    this.topToolbarService.clearButtons();
  }
}
